function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .reversarIcon {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uG4Cz2.tif"
}, /*#__PURE__*/React.createElement("path", {
  className: "reversarIcon",
  d: "M6.3,24.2c-2.1,0-3.8,0-5.6,0-.6,0-.7-.2-.8-.8,0-.7,0-1.5,0-2.2,0-.7.1-.8.8-.8,3.2,0,6.3,0,9.5,0,3.2,0,5.8-1.9,6.6-4.9,1.1-3.9-1.6-7.8-5.5-8.4-.3,0-.4,0-.4.3,0,.7,0,1.4,0,2.1,0,.3,0,.5-.3.6-.3.1-.5,0-.7-.1-1.9-1.5-3.8-3-5.6-4.5-.4-.3-.4-.7,0-1,1.9-1.5,3.7-2.9,5.6-4.4.2-.2.5-.3.7-.1.3.1.3.4.3.6,0,.7,0,1.4,0,2.1,0,.3,0,.4.4.5,4.6.5,8.1,3.6,9.2,7.9,1.5,6-2.7,12.1-8.9,12.9-1.9.2-3.9,0-5.5,0Z"
}));

var SvgReversar = function SvgReversar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reversarIcon",
    "data-name": "Layer 1",
    viewBox: "0 0 21 24.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReversar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Reversar.81d78a57.svg";
export { ForwardRef as ReactComponent };